module.exports = "<span\n  *ngIf=\"errors[field]\"\n  [pTooltip]=\"errors[field]\"\n  aria-hidden=\"true\"\n  class=\"fa fa-exclamation-triangle\"\n  tooltipPosition=\"left\"\n>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/import/import-error/import-error.component.html
// module id = ../../../../../src/app/import/import-error/import-error.component.html
// module chunks = main